import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { selectCurrentContactId } from 'ducks/crm/contacts'

import { doFetchRecentConversationsAndRooms } from './operations'
import {
  selectIsOrWillBeLoadingRecentConversationsAndChatsForCurrentContact,
  selectRecentConversationsAndChatsForCurrentContact,
} from './selectors'

export function useRecentConversations() {
  const contactId = useSelector(selectCurrentContactId)
  const dispatch = useDispatch()
  useEffect(
    () => {
      if (contactId) dispatch(doFetchRecentConversationsAndRooms(contactId))
    },
    [dispatch, contactId]
  )
  const conversations = useSelector(
    selectRecentConversationsAndChatsForCurrentContact
  )
  return {
    isLoading: useSelector(
      selectIsOrWillBeLoadingRecentConversationsAndChatsForCurrentContact
    ),
    hasConversations: conversations?.length > 0,
    conversations,
  }
}
